import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d2ea746"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asterisk" }, "*", -1))
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asterisk" }, "*", -1))
const _hoisted_5 = { class: "btn-content" }

import {
  computed, ref, reactive,
} from 'vue';
import type { FormInstance } from 'element-plus';
import { useRoute } from 'vue-router';

import store from '@/store';
import { GetterCommands } from '@/store/getters';
import { transfer } from '@/common/contracts/apis/nft/nft-detail-api';
import NecoDialog from '@/components/NecoDialog.vue';

// const { locale, t } = useI18n();


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: Boolean,
  data: Object,
},
  emits: ['update:visible', 'submit'],
  setup(__props, { emit }) {

const props = __props




const route = useRoute();
const { id: nftId } = route.params;

const innerVisible = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});

const formRef = ref<FormInstance>();
const formData = reactive({
  address: '',
  amount: 1,
});

async function onSubmit(formEl: FormInstance | undefined) {
  if (!formEl) return;
  await formEl.validate();
  const currentAccount = store.getters[GetterCommands.GET_CURRENT_ACCOUNT];
  if (!currentAccount) return;
  innerVisible.value = false;
  await transfer(currentAccount, formData.address, nftId as string, formData.amount);
}

function beforeClose() {
  formData.address = '';
  formData.amount = 1;
}

const validateAmount = (rule: any, value: any, callback: any) => {
  if (!value || value < 1) {
    callback(new Error('Amount should greater than 0'));
  } else {
    callback();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(NecoDialog, {
    visible: _unref(innerVisible),
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(innerVisible) ? (innerVisible).value = $event : null)),
    "d-title": _ctx.$t('transfer'),
    onClose: beforeClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(formData),
        "status-icon": "",
        "label-width": "120px",
        class: "demo-ruleForm",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('inputAddress'),
            prop: "address",
            rules: [{ required: true, message: _ctx.$t('inputAddress'), trigger: 'blur' }]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).address,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).address) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["label", "rules"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('inputAmount'),
            prop: "amount",
            rules: [
                      { required: true, message: _ctx.$t('inputAmount'), trigger: 'blur' },
                      { validator: validateAmount, trigger: 'blur' }
                    ]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).amount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).amount) = $event)),
                  modelModifiers: { number: true }
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["label", "rules"]),
          _createVNode(_component_el_form_item, { class: "submit-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onSubmit(formRef.value))),
                class: "btn approve-btn",
                size: "medium"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('confirm')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "d-title"]))
}
}

})